import defaultConfig from '../../configs/defaultConfig';
import helpers from '../../utils/helpers';
import log from '../logger/log';

const mergeUwmConfig = (currentUwmConfig = [], newUwmConfig) => {
    const mergedUwmConfig = [...currentUwmConfig];

    for (const newModule of newUwmConfig) {
        const index = mergedUwmConfig.findIndex(({feature}) => feature === newModule.feature);

        if (index === -1) mergedUwmConfig.push(newModule);
        else mergedUwmConfig[index] = {...mergedUwmConfig[index], ...newModule};
    }

    return mergedUwmConfig;
};

const withMergedUwmConfig = (currentConfig, newConfig) => {
    const mergedConfig = {...newConfig};

    if (Array.isArray(mergedConfig.uwmConfig)) {
        mergedConfig.uwmConfig = mergeUwmConfig(currentConfig.uwmConfig, mergedConfig.uwmConfig);
    } else {
        delete mergedConfig.uwmConfig;
    }

    return mergedConfig;
};

class ConfigManager {
    constructor() {
        this.config = {};
        this.baseConfig = null;
        this.isInitialized = false;
    }

    initialize() {
        if (this.isInitialized) {
            log.info('ConfigManager: Config already initialized. Skipping initialization.');
            return;
        }

        this.config = {...defaultConfig};
        this.isInitialized = true;
    }

    saveBase() {
        this.baseConfig = this.config;
    }

    reset() {
        this.config = this.baseConfig ?? {...defaultConfig};
    }

    mergeConfig(newConfig) {
        if (!newConfig) {
            log.error('ConfigManager: No config provided to merge');
            return;
        }

        this.config = helpers.mergeDeep(this.config, withMergedUwmConfig(this.config, newConfig));

        log.debug('ConfigManager: Config successfully updated');
    }

    getConfig() {
        if (!this.isInitialized) {
            log.error('ConfigManager: Config not initialized.');
            return;
        }

        return this.config;
    }
}

export default ConfigManager;
